import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../store/userSlice";
import nodeinstance from "../../../../nodeInstance";

import { useNavigate } from "react-router-dom";
import UploadFilePopUp from "../../../../ReusableComponents/UploadFile/uplaodFile";

export default function financeDeskEmployeeDetails({
  data,
  setAction,
  setnewIndex = { setnewIndex },
}) {
  const [listData, setListData] = useState([]);
  useEffect(() => {
    setListData(data);
  }, [data]);

  const token = localStorage.getItem("nodeToken");
  const [Popup, setPopUp] = useState(false);
  const [accountsList, setAccountsList] = useState({
    client_expense_type: "",
    client_expense: "",
    employee_expense: "",
    SLA_type: "",
    SLA: "",
    employee_expense_type: "",
  });
  const [loading, setLoading] = useState(false);

  function handleChange(e) {
    const { name, value } = e.target;
    setAccountsList((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  }
  const [dependents, setDependents] = useState("ADD DEPENDENT");

  const handleaddclick = () => {};

  const handleInputChange = (data, e, index) => {
    setListData((prev) => {
      const updatedListData = [...prev];
      updatedListData[index] = {
        ...updatedListData[index],
        [data]: e.target.value,
      };
      return updatedListData;
    });
    console.log(data);
  };

  const update = async () => {
    console.log("Backend data..............", listData);
    let data = {
      emp_id: listData && listData[0]?.Employee_Unique_Id,
      key: dependents,
      client_expense_type: accountsList.client_expense_type,
      client_expense: accountsList.client_expense,
      employee_expense: accountsList.employee_expense,
      SLA_type: accountsList.SLA_type,
      SLA: accountsList.SLA,
      Status : "APPROVED BY FINANCE",
      Insurance_Flow_Type : "INSURANCE VENDOR PAYMENT",
      dependent_details: listData.map((e) => ({
        dependent_name: e.dependent_name,
        dependent_dob: e.dependent_dob,
        dependent_nationality: e.dependent_nationality,
        dependent_iqama_number: e.dependent_iqama_number,
        dependent_relation: e.dependent_relation,
        dependent_gender: e.dependent_gender,
        amount: e.amount,
      })),
    };
    console.log(".........data..........", data);
    setLoading(true);
    try {
      const response = await nodeinstance.post(
        `/insurance-dependent/addDependentDetails`,
        data,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        dispatch(
          setAppError({
            msg: "Successfully uploaded.",
            color: "success",
          })
        );

        setLoading(false);
      }

      setAction(false);
      setnewIndex(2);
    } catch (error) {
      setLoading(false);
      dispatch(
        setAppError({
          msg: error.message,
        })
      );
    }
  };
  const dispatch = useDispatch();

  function dependentsHandeler(title) {
    setDependents(title);
  }

  //  console.log(item);

  return (
    <div className="mt-5">
      <div></div>

      {/* employee details */}

      <div className="mt-4">
        <p className="text-xl font-semibold">EMPLOYEE DETAILS:</p>
        <div className="flex justify-between ">
          <div className="flex flex-col  w-[49.8%]">
            <div className="text-balck text-xl flex mt-1 font-medium">
              <p className="bg-[#4F81BD] w-[50%] p-1 ">EMPLOYEE NAME</p>
              <p className="bg-white w-[50%] text-center ">
                {data[0]?.dependent_name ?? "-"}
              </p>
            </div>
            <div className="text-balck text-xl flex mt-1 font-medium">
              <p className="bg-[#4F81BD] w-[50%] p-1 ">DOB</p>
              <p className="bg-white w-[50%] text-center ">
                {/* {data[0].dependent_dob ?? "-"} */}
                {data[0]?.dependent_dob
                  ? new Date(data[0]?.dependent_dob)
                      .toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      })
                      .split(" ")
                      .join("-")
                      .toUpperCase()
                  : "-----"}
              </p>
            </div>
            <div className="text-balck text-xl flex mt-1 font-medium">
              <p className="bg-[#4F81BD] w-[50%] p-1 ">KSA ARRIVAL DATE</p>
              <p className="bg-white w-[50%] text-center ">
                {/* {data[0].ksa_arrival_date ?? "-"} */}
                {data[0]?.ksa_arrival_date
                  ? new Date(data[0]?.ksa_arrival_date)
                      .toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      })
                      .split(" ")
                      .join("-")
                      .toUpperCase()
                  : "-----"}
              </p>
            </div>
            <div className="text-balck text-xl flex mt-1 font-medium">
              <p className="bg-[#4F81BD] w-[50%] p-1 ">NATIONALITY</p>
              <p className="bg-white w-[50%] text-center ">
                {data[0].nationality ?? "-"}
              </p>
            </div>
            <div className="text-balck text-xl flex mt-1 font-medium">
              <p className="bg-[#4F81BD] w-[50%] p-1 ">IQAMA NUMBER</p>
              <p className="bg-white w-[50%] text-center ">
                {data[0].iqama_number ?? "-"}
              </p>
            </div>
            <div className="text-balck text-xl flex mt-1 font-medium">
              <p className="bg-[#4F81BD] w-[50%] p-1 ">PASSPORT NUMBER</p>
              <p className="bg-white w-[50%] text-center ">
                {data[0].passport_number ?? "-"}
              </p>
            </div>
            <div className="text-balck text-xl flex mt-1 font-medium">
              <p className="bg-[#4F81BD] w-[50%] p-1 ">CLIENT NAME</p>
              <p className="bg-white w-[50%] text-center ">
                {data[0].client_name ?? "-"}
              </p>
            </div>
            <div className="text-balck text-xl flex mt-1 font-medium">
              <p className="bg-[#4F81BD] w-[50%] p-1 ">TOTAL SALARY</p>
              <p className="bg-white w-[50%] text-center ">
                {data[0].total_salary ?? "-"}
              </p>
            </div>
          </div>
          <div className="  w-[49.8%] font-medium">
            <div className=" text-xl flex mt-1 ">
              <p className="bg-[#4F81BD]  w-[50%] p-1">SLA EMP ID:</p>
              <p className="bg-white  w-[50%] text-center">
                {data[0].emp_id ?? "-"}
              </p>
            </div>

            <div className=" text-balck text-xl flex mt-1">
              <p className="bg-[#CFD7E7]  w-[50%] p-1">ACTUAL PROFESSION:</p>
              <p className="bg-white  w-[50%] text-center">
                {data[0].actual_profession ?? "-"}
              </p>
            </div>

            <div className="text-balck text-xl flex mt-1">
              <p className="bg-[#E8ECF4]  w-[50%] p-1">BORDER NUMBER:</p>
              <p className="bg-white  w-[50%] text-center">
                {data[0].border_number ?? "-"}
              </p>
            </div>

            <div className="text-balck text-xl flex mt-1">
              <p className="bg-[#CFD7E7]  w-[50%] p-1">CURRENT SPONSOR:</p>
              <p className="bg-white  w-[50%] text-center">
                {data[0].current_sponsor ?? "-"}
              </p>
            </div>

            <div className="text-balck text-xl flex mt-1">
              <p className="bg-[#E8ECF4]  w-[50%] p-1">IQAMA EXPIRY DATE:</p>
              <p className="bg-white  w-[50%] text-center">
                {/* {data[0].iqama_expiry_date_g ?? "-"} */}
                {data[0].iqama_expiry_date_g
                  ? new Date(data[0].iqama_expiry_date_g)
                      .toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      })
                      .split(" ")
                      .join("-")
                      .toUpperCase()
                  : "-----"}
              </p>
            </div>

            <div className="text-balck text-xl flex mt-1">
              <p className="bg-[#CFD7E7]  w-[50%] p-1">PASSPORT EXPIRY DATE:</p>
              <p className="bg-white  w-[50%] text-center">
                {/* {data[0].passport_expiry_date ?? "-"} */}
                {data[0].passport_expiry_date
                  ? new Date(data[0].passport_expiry_date)
                      .toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      })
                      .split(" ")
                      .join("-")
                      .toUpperCase()
                  : "-----"}
              </p>
            </div>

            <div className="text-balck text-xl flex mt-1">
              <p className="bg-[#E8ECF4]  w-[50%] p-1">PROJECT NAME:</p>
              <p className="bg-white  w-[50%] text-center">
                {data[0].project ?? "-"}
              </p>
            </div>
            <div className="text-balck text-xl flex mt-1">
              <p className="bg-[#CFD7E7]  w-[50%] p-1 ">
                INSURANCE COMPANY NAME:
              </p>
              <p className="bg-white  w-[50%] text-center">
                {data[0].company_name ?? "-"}
              </p>
            </div>

            <div className="text-balck text-xl flex mt-1">
              <p className="bg-[#CFD7E7]  w-[50%] p-1 ">INSURANCE CLASS:</p>
              <p className="bg-white  w-[50%] text-center">
                {data[0].insurance_class ?? "-"}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* buttons */}
      <div className="flex justify-center mt-8 gap-x-10 font-semibold">
        <label
          className="flex gap-x-1"
          onClick={() => dependentsHandeler("UPGRADE")}
        >
          <input type="radio" name="selection" />
          <p>UPGRADE</p>
        </label>

        <label
          className="flex gap-x-1"
          onClick={() => dependentsHandeler("ADD DEPENDENT")}
        >
          <input type="radio" name="selection" defaultChecked />
          <p>ADD DEPENDENTS</p>
        </label>
      </div>

      {/* dependent details */}

      <div className="mt-4  w-[100%]  min-h-[120px] max-h-[250px] overflow-y-auto overflow-x-hidden">
        <p className="font-semibold text-xl ">DEPENDENTS DETAILS:</p>
        <button onClick={handleaddclick}>Add</button>
        <table className="mt-4 border-2 border-white w-[100%]">
          <tr className="  bg-black text-white p-2 border border-white">
            <th className=" px-4 border border-white">S.NO</th>
            <th className="px-4 border border-white">DEPENDENT NAME</th>
            <th className="px-4 border border-white">DATE OF BIRTH</th>
            <th className="px-4 border border-white">NATIONALITY</th>
            <th className="px-4 border border-white">IQAMA NUMBER</th>
            <th className="px-4 border border-white">RELATION</th>
            <th className="px-4 border border-white text-nowrap">
              INSURANCE CLASS
            </th>
            <th className="px-4 border border-white">GENDER</th>
            <th className="px-4 border border-white">AMOUNT</th>
          </tr>

          {listData.map((x, i) => {
            return (
              <tr key={i}>
                <td className=" border border-white text-center">{i + 1}</td>
                <td className=" border border-white ">
                  {dependents === "ADD DEPENDENT" ? (
                    <input
                      type="text"
                      className="outline-none"
                      name="dependent_name"
                      onChange={(event) =>
                        handleInputChange("dependent_name", event, i)
                      }
                      placeholder={x.name}
                      value={listData[i].dependent_name} // Ensure each input value reflects the corresponding state value
                    />
                  ) : (
                    <p>POPULATE</p>
                  )}
                </td>
                <td className=" border border-white">
                  {dependents === "ADD DEPENDENT" ? (
                    <input
                      type="text"
                      className="outline-none"
                      name="dependent_dob"
                      onChange={(event) =>
                        handleInputChange("dependent_dob", event, i)
                      }
                      placeholder={x.name}
                      // value={listData[i].dependent_dob}
                      value={
                        listData[i].dependent_dob
                          ? new Date(listData[i].dependent_dob)
                              .toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              })
                              .split(" ")
                              .join("-")
                              .toUpperCase()
                          : "-----"
                      }
                    />
                  ) : (
                    <p>POPULATE</p>
                  )}
                </td>
                <td className=" border border-white">
                  {dependents === "ADD DEPENDENT" ? (
                    <input
                      type="text"
                      className="outline-none"
                      name="dependent_nationality"
                      onChange={(event) =>
                        handleInputChange("dependent_nationality", event, i)
                      }
                      placeholder={x.name}
                      value={listData[i].dependent_nationality} // Ensure each input value reflects the corresponding state value
                    />
                  ) : (
                    <p>POPULATE</p>
                  )}
                </td>
                <td className="border border-white">
                  {dependents === "ADD DEPENDENT" ? (
                    <input
                      type="text"
                      className="outline-none"
                      name="dependent_iqama_number"
                      onChange={(event) =>
                        handleInputChange("dependent_iqama_number", event, i)
                      }
                      placeholder={x.name}
                      value={listData[i].dependent_iqama_number} // Ensure each input value reflects the corresponding state value
                    />
                  ) : (
                    <p>POPULATE</p>
                  )}
                </td>
                <td className=" border border-white">
                  <select
                    className="outline-none"
                    name="dependent_relation"
                    onChange={(event) =>
                      handleInputChange("dependent_relation", event, i)
                    }
                    placeholder={x.name}
                    value={listData[i].dependent_relation}
                  >
                    <option>WIFE</option>
                    <option>SON</option>
                    <option>DAUGHTER</option>
                    <option>MOTHER</option>
                    <option>FATHER</option>
                  </select>
                </td>
                <td className=" border border-white text-center">
                  {dependents === "ADD DEPENDENT" ? (
                    <p>AS PER MASTER</p>
                  ) : (
                    <p>POPULATE</p>
                  )}
                </td>
                <td className=" border border-white">
                  <select
                    className="outline-none"
                    name="dependent_gender"
                    onChange={(event) =>
                      handleInputChange("dependent_gender", event, i)
                    }
                    placeholder={x.name}
                    value={listData[i].dependent_gender}
                  >
                    <option>Male</option>
                    <option>Female</option>
                  </select>
                </td>
                <td className=" border border-white">
                  <input
                    type="text"
                    className="outline-none"
                    name="amount"
                    onChange={(event) => handleInputChange("amount", event, i)}
                    placeholder={x.name}
                    value={listData[i].amount}
                  />
                </td>
              </tr>
            );
          })}
        </table>
      </div>

      {/* for accounts */}

      <div className="mt-10">
        <p className="text-xl font-semibold">FOR ACCOUNTS:</p>
        <table className="border-2 border-gray w-[100%] mt-2">
          <tr>
            <td className="px-4 py-4 border border-gray font-semibold">
              CLIENT EXPENSE:
            </td>
            <td className="px-4 py-4 border border-gray">
              <label className="flex gap-x-1">
                <input
                  type="radio"
                  name="client_expense_type"
                  onChange={handleChange}
                  checked={
                    accountsList.client_expense_type ===
                    "INVOICE UPFRONT PAYMENT"
                  }
                  value="INVOICE UPFRONT PAYMENT"
                />
                <p>INVOICE UPFRONT PAYMENT</p>
              </label>
            </td>
            <td className="px-4 py-4 border border-gray">
              <label className="flex gap-x-1">
                <input
                  type="radio"
                  name="client_expense_type"
                  onChange={handleChange}
                  checked={
                    accountsList.client_expense_type === "INVOICE LATER PAYMENT"
                  }
                  value="INVOICE LATER PAYMENT"
                />
                <p>INVOICE LATER PAYMENT</p>
              </label>
            </td>
            <td className="px-4 py-4 border border-gray ">
              <label className="flex  gap-x-2 w-full">
                <p>SAR/</p>
                <input
                  type="number"
                  className="w-full"
                  onChange={handleChange}
                  value={accountsList.client_expense}
                  name="client_expense"
                />
              </label>
            </td>
          </tr>

          <tr>
            <td className="px-4 border border-gray font-semibold">
              EMPLOYEE EXPENSE:
            </td>
            <td className="px-4 border border-gray">
              <label className="flex gap-x-1">
                <input
                  type="radio"
                  name="employee_expense_type"
                  onChange={handleChange}
                  checked={
                    accountsList.employee_expense_type ===
                    "DEDUCTABLE FROM SALARY"
                  }
                  value="DEDUCTABLE FROM SALARY"
                />
                <p>DEDUCTABLE FROM SALARY</p>
              </label>
            </td>
            <td className="px-4 border border-gray">
              <label className="flex gap-x-1">
                <input
                  type="radio"
                  name="employee_expense_type"
                  onChange={handleChange}
                  checked={
                    accountsList.employee_expense_type === "INSTALLMENT-1"
                  }
                  value="INSTALLMENT-1"
                />
                <p>INSTALLMENT-1</p>
              </label>
              <label className="flex gap-x-1">
                <input
                  type="radio"
                  name="employee_expense_type"
                  onChange={handleChange}
                  checked={
                    accountsList.employee_expense_type === "INSTALLMENT-2"
                  }
                  value="INSTALLMENT-2"
                />
                <p>INSTALLMENT-2</p>
              </label>
              <label className="flex gap-x-1">
                <input
                  type="radio"
                  name="employee_expense_type"
                  onChange={handleChange}
                  checked={
                    accountsList.employee_expense_type === "INSTALLMENT-3"
                  }
                  value="INSTALLMENT-3"
                />

                <p>INSTALLMENT-3</p>
              </label>
            </td>
            <td className="px-4 py-7 border border-gray">
              <label className="flex  gap-x-2 w-full">
                <p>SAR/</p>
                <input
                  type="number"
                  className="w-full"
                  onChange={handleChange}
                  value={accountsList.employee_expense}
                  name="employee_expense"
                />
              </label>
            </td>
          </tr>

          <tr>
            <td className="px-4 py-4 border border-gray font-semibold">SLA:</td>
            <td className="px-4 py-4 border border-gray">
              <label className="flex gap-x-1">
                <input
                  type="radio"
                  name="SLA_type"
                  onChange={handleChange}
                  checked={accountsList.SLA_type === "INCLUDE IN CHARGE"}
                  value="INCLUDE IN CHARGE"
                />
                <p>INUCLUDE IN CHARGE </p>
              </label>
            </td>
            <td className="px-4 py-4 border border-gray">
              <label className="flex gap-x-1">
                <input
                  type="radio"
                  name="SLA_type"
                  onChange={handleChange}
                  checked={accountsList.SLA_type === "SLA EXPENSE"}
                  value="SLA EXPENSE"
                />
                <p>SLA EXPENSE</p>
              </label>
            </td>
            <td className="px-4 py-7 border border-gray ">
              <label className="flex w-full  gap-x-2">
                <p>SAR/</p>
                <input
                  type="number"
                  className="w-full"
                  onChange={handleChange}
                  value={accountsList.SLA}
                  name="SLA"
                />
              </label>
            </td>
          </tr>
        </table>
      </div>

      {/* buttons */}

      <div className="flex mt-3 justify-between">
        <button
          className="bg-black text-white px-10 rounded-md py-1 text-sm h-[38px]"
          onClick={() => setPopUp(true)}
        >
          UPLOAD DOCUMENTS
        </button>

        <button
          className="bg-red text-white px-10 rounded-md py-1 text-sm h-[38px]"
          onClick={() => update()}
        >
          APPROVE
        </button>
      </div>
      {Popup ? (
        <UploadFilePopUp
          PopUp={Popup}
          setPopUp={setPopUp}
          title={"UPLOAD INSURANCE DEPENDENT"}
          url={"/employees/updateBorderNumbersFromExcel"}
          callBack={apiCall}
        />
      ) : (
        ""
      )}
    </div>
  );
}
